var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepositoryScanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 1.72727H1.7V4.31818H0V0H4.25V1.72727ZM17 4.31818V0H12.75V1.72727H15.3V4.31818H17ZM4.25 17.2727H1.7V14.6818H0V19H4.25V17.2727ZM15.3 14.6818V17.2727H12.75V19H17V14.6818H15.3ZM12.75 4.31818H4.25V14.6818H12.75V4.31818ZM14.45 14.6818C14.45 15.6318 13.685 16.4091 12.75 16.4091H4.25C3.315 16.4091 2.55 15.6318 2.55 14.6818V4.31818C2.55 3.36818 3.315 2.59091 4.25 2.59091H12.75C13.685 2.59091 14.45 3.36818 14.45 4.31818V14.6818ZM11.05 6.04545H5.95V7.77273H11.05V6.04545ZM11.05 8.63636H5.95V10.3636H11.05V8.63636ZM11.05 11.2273H5.95V12.9545H11.05V11.2273Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepositoryScanIcon);
export default __webpack_public_path__ + "static/media/repositoryScanIcon.10cdded80a10d62b7f9282e6d729ae52.svg";
export { ForwardRef as ReactComponent };